@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.SuperScript {
  @extend %font-family-primary;

  position: relative;

  .NumberCircle {
    position: absolute;
    bottom: 12px;
    right: -3px;
    top: -10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    height: 10px;
    border-radius: 100px;
    z-index: 1;
    padding: 2px 4px;
    color: $color-white;

    &.green {
      background: $color-secondary-green;
      text-shadow:
        -1px -1px 0 $color-secondary-green,
        1px -1px 0 $color-secondary-green,
        -1px 1px 0 $color-secondary-green,
        1px 1px 0 $color-secondary-green;
    }

    &.purple {
      background: $color-brand-primary;
      text-shadow:
        -1px -1px 0 $color-brand-primary,
        1px -1px 0 $color-brand-primary,
        -1px 1px 0 $color-brand-primary,
        1px 1px 0 $color-brand-primary;
    }

    &.red {
      background: $color-warning;
      text-shadow:
        -1px -1px 0 $color-warning,
        1px -1px 0 $color-warning,
        -1px 1px 0 $color-warning,
        1px 1px 0 $color-warning;
    }
  }

  .IconCircle {
    position: absolute;
    bottom: 12px;
    right: -5px;
    top: -18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    height: 10px;
    border-radius: 100px;
    z-index: 1;
    padding: 2px 6px;
    color: $color-white;

    &.purple {
      background: $color-brand-primary;
      text-shadow:
        -1px -1px 0 $color-brand-primary,
        1px -1px 0 $color-brand-primary,
        -1px 1px 0 $color-brand-primary,
        1px 1px 0 $color-brand-primary;
    }
  }
}
